import { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import StepsComponent from './stepscomponent'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const TutorialTabsContainer = styled.div`
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1068px;
`

const TabsContainer = styled.div`
    width: 100%;
    height: 68px;
    display: flex;
    flex-direction: row;
`

interface Props {
    $selected: boolean
}

const TabItem = styled.div<Props>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 48px;
    width: 100%;
    background-color: ${(p) => (p.$selected ? '#fafafa' : '#EEE9E4')};
    cursor: pointer;
`

const TabLabelText = styled.div<Props>`
    color: ${(p) => (p.$selected ? '#C5924D' : '#877')};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

interface StepItem {
    id: string
    parentid: string
    path_en?: string
    path_zh?: string
    step_en?: string
    step_zh?: string
    text_en?: string
    text_zh?: string
    content_en?: string
    content_zh?: string
}

interface StepItems extends Array<StepItem> {}

interface TutorialTab {
    id: string
    tabNameEN: string
    tabNameCN: string
    steps: StepItems
}

export default function TutorialTabs() {
    const [selectedTab, setSelectedTab] = useState('1')
    const { i18n } = useTranslation('', {
        keyPrefix: 'spendwins.tutorialtabs',
    })

    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)
    const tutorialTabs = configs?.spendwins?.tutorialTabs || []

    const tabOnClick = (value: string) => {
        setSelectedTab(value)
        const selectedTabName = tutorialTabs.find(
            (tutorialTab: TutorialTab) => tutorialTab.id.toString() === value
        )
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_clickTab_SpendWins_Tutorial_${selectedTabName?.tabNameEN}`,
        })
    }

    return (
        <TutorialTabsContainer>
            <TabsContainer>
                {tutorialTabs.map((tutorialTab: TutorialTab, index: number) => (
                    <TabItem
                        key={'use-wins-step-' + index}
                        $selected={selectedTab === tutorialTab.id}
                        onClick={() => tabOnClick(tutorialTab.id)}
                    >
                        <TabLabelText
                            $selected={selectedTab === tutorialTab.id}
                        >
                            {lang === 'zh'
                                ? tutorialTab.tabNameCN
                                : tutorialTab.tabNameEN}
                        </TabLabelText>
                    </TabItem>
                ))}
            </TabsContainer>
            {tutorialTabs ? (
                <StepsComponent
                    key={selectedTab}
                    stepItems={
                        tutorialTabs.filter(
                            (tab: StepItem) => tab.id === selectedTab
                        )[0]?.steps || null
                    }
                />
            ) : null}
        </TutorialTabsContainer>
    )
}
